module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    attrs: {
      "id": _vm.templateId
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc74701c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Select2.vue
// module id = 819
// module chunks = 1